// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"c973196b","137":"e1927e46","150":"80e9f89a","173":"202b4d79","190":"91861487","211":"7b71ad39","220":"238ad58e","328":"ca5d7a9d","448":"94596f5a","509":"3f56a764","585":"867200d8","595":"c8266c2a","613":"b698f478","634":"a556bc23","655":"a476e0c8","748":"af242e5e"}[chunkId] + ".chunk.js";
};